import { GDTMessageStatus, HL7MessageDto } from '@lmt/shared-types';
import { addMinutes } from 'date-fns';
import { CaseTreeItemType, TransportInfo, TransportStatus } from '../../types';

export function getItemPrefix(itemId: string) {
  return itemId.split('_', 2).join('_');
}

export function getUTCDate(date: Date) {
  const result = addMinutes(date, date.getTimezoneOffset());
  return result;
}

export function getTransportStatus(message: {
  error?: string | null;
  status: GDTMessageStatus;
}): TransportStatus {
  if (!!message.error) {
    return TransportStatus.error;
  } else if (message.status === GDTMessageStatus.Processed) {
    return TransportStatus.success;
  } else {
    return TransportStatus.progress;
  }
}

export function getMeasurementOptions(data?: TransportInfo):
  | {
      type: CaseTreeItemType.empty;
      options: null;
    }
  | {
      type: CaseTreeItemType.transportStatus;
      options: TransportInfo;
    } {
  if (!data) {
    return {
      type: CaseTreeItemType.empty,
      options: null,
    };
  } else {
    return {
      type: CaseTreeItemType.transportStatus,
      options: data,
    };
  }
}
